import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://sent-i-meter.com";
const SITE_NAME = "Sent-i-meter";
const DEFAULT_OG = `${SITE_URL}/icon-512.png`;

// Centralised per-route SEO. Pass an object describing the page; the component
// emits <title>, meta description/keywords, canonical, OpenGraph, Twitter card,
// and optional structured-data JSON-LD.
//
// Usage:
//   <SEO
//     title="Luxury Watches Sentiment Index"
//     description="..."
//     path="/watches"
//     keywords={["luxury watches", "rolex sentiment"]}
//     jsonLd={{...}}
//   />
export default function SEO({
  title,
  description,
  path = "",
  keywords,
  image = DEFAULT_OG,
  jsonLd,
  noindex = false,
}) {
  const fullTitle = title ? `${title} · ${SITE_NAME}` : `${SITE_NAME} · Global Market Sentiment`;
  const url = path ? `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}` : SITE_URL;
  const kw = Array.isArray(keywords) ? keywords.join(", ") : keywords;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {kw && <meta name="keywords" content={kw} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* OpenGraph */}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
